import {CheatPlugin} from '../../CheatModuleInterfaces';
import {CheatMatrixController} from './CheatMatrixController';
import {CheatMatrixView} from './CheatMatrixView';

const matrix: CheatPlugin = {
    name: 'Matrix Cheat',
    init: () => [
        CheatMatrixController,
        CheatMatrixView
    ]
};

export default matrix;
